import axios from "../../../../../../axios";
import React from "react";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../../../../On_going_PreRead/Draft/Draft_Assess_Box/Draft_Q_list/draft_Q_list_PreRead.css";
import DraftPublishPreRead from "../DraftPreReadPublish/DraftPublishPreRead";
import PreDraftAttach from "./PreDraftAttach";
import { Form } from "react-bootstrap";
import debounce from "lodash/debounce";
import Camera from "react-html5-camera-photo";
import ReportProblemRoundedIcon from "@mui/icons-material/ReportProblemRounded";
import {
  Box,
  Stack,
  Typography,
  TextField,
  Button,
  Paper,
  CircularProgress,
  Divider,
  Link as MuiLink,
  IconButton,
} from "@mui/material";
import assets from "../../../../../../assets/assets";
import AddLinkPopup from "../../../../../../ContentManagement/LiveSession/LiveSessionDetail.js/SubjectDatailsCM/AddLinkPopup";
import { toast } from "react-toastify";

export default function Draft_Q_list_PreRead() {
  const navigate = useNavigate();
  const [publish, setPublish] = useState();
  //Added this state by kuldeep
  const { state } = useLocation();
  let Teacher_id = localStorage.getItem("Teacher_id");
  let Teacher_Json = JSON.parse(Teacher_id);
  const [updatePreread, setUpdatePreread] = useState({
    description: "",
    updateTittle: "",
    attach: [],
  });
  const [linkValue, setLinkValue] = useState("");
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const { description, attach, updateTittle } = updatePreread;
  const [showLinkBox, setShowLinkBox] = useState(false);
  const [preDraftData, setpreDraftData] = useState({
    draftPreRead: [],
  });
  const [visible, setVisible] = useState(false);
  const [isValidFileType, setIsValidFileType] = useState(true);
  const [loader, setLoader] = useState(false);
  const [cameraError, setCameraError] = useState(null);
  const [errorsize, setErrorSize] = useState(false);
  const { draftPreRead } = preDraftData;
  const isProcessing = loader;
  const academicSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );
  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );
  useEffect(() => {
    const getDraftPreRead = async () => {
      try {
        const res = await axios.get(
          `/api/v1/homework/preRead/getById/${state.draftPre_id}`,
        );
        res &&
          setpreDraftData({
            draftPreRead: res.data.data,
          });
        setUpdatePreread({
          ...updatePreread,
          description: res?.data.data.description,
          updateTittle: res?.data.data.name,
          attach: res?.data.data.attachments,
        });
      } catch (error) {}
    };
    getDraftPreRead();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  console.log(draftPreRead, "draftPreRead");

  let createPreRead = {
    name: updateTittle,
    description: description,
    standard_id: draftPreRead?.standard_id?.id,
    subject_id: draftPreRead?.subject_id?.id,
    teacher_id: Teacher_Json,
    academic_session_id: academicSessionId,
    timetable_session_id: timeTableSessionId,
    section_id: draftPreRead?.section_id?.id,
    book_id: draftPreRead?.book_id?.id,
    chapter_id: draftPreRead?.chapter_id?.id,
    type: draftPreRead?.type?.id,
    attachments: attach,
    status: "draft",
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!validateFile(file)) return;

    const formData = new FormData();
    formData.append("uploadPreReadAttachment", file);

    try {
      setLoader(true);

      const response = await axios.post(
        `/api/v1/preRead/uploadAttachment/teacherId/${Teacher_Json}`,
        formData,
      );

      const fileUrl = response?.data?.data;

      if (!fileUrl) {
        toast.error("Upload failed");
        return;
      }

      setUpdatePreread((prev) => ({
        ...prev,
        attach: [...(prev.attach || []), fileUrl],
      }));
    } catch (error) {
      console.error(error);
      toast.error("Upload failed");
    } finally {
      setLoader(false);
    }
  };

  const validateFile = (file) => {
    const allowedExtensions = /\.(jpg|jpeg|png|pdf|mp3|mp4|pptx|ppt)$/i;

    // ✅ total attachments count (ALL types)
    if (attach.length >= 5) {
      toast.error("Maximum 5 attachments allowed");
      return false;
    }

    // ❌ invalid type
    if (!allowedExtensions.exec(file.name)) {
      toast.error("Invalid file type");
      return false;
    }

    // ❌ size check
    if (file.size > 10 * 1024 * 1024) {
      toast.error("File must be under 10MB");
      return false;
    }

    return true;
  };
  async function handleTakePhoto(dataUri) {
    const now = new Date();

    // Format date parts
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();

    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    const fileExtension = "jpg" || "jpeg" || "png";
    const filename = `capture-${day}-${month}-${year}-${hours}:${minutes}:${seconds}.${fileExtension}`;
    console.log("filename", filename);

    const link = document.createElement("a");
    link.href = dataUri;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    try {
      const capture = await fetch(dataUri).then((res) => res.blob());
      const fileWithProperExtension = new File([capture], filename, {
        type: capture.type || "image/jpeg",
      });

      if (
        fileWithProperExtension.size <= 25 * 1024 * 1024 &&
        validateFile(fileWithProperExtension)
      ) {
        const formData = new FormData();
        formData.append("name", filename);
        formData.append("uploadPreReadAttachment", fileWithProperExtension);
        // formData.append("image", blob, `${new Date().getTime()}.jpg`); // Provide a filename
        console.log("formData", formData);

        let response = await axios.post(
          `/api/v1/preRead/uploadAttachment/teacherId/${Teacher_Json}`,
          formData,
        );

        if (response) {
          setUpdatePreread((prev) => {
            const prevAttach = Array.isArray(prev.attach) ? prev.attach : [];
            return {
              ...prev,
              attach: [...prevAttach, response.data.data],
            };
          });
          response && setLoader(false);
        } else {
          console.error("Failed to upload photo:", response.statusText);
          alert("Failed to upload photo.");
        }
      } else {
        setIsValidFileType(false);
      }
    } catch (error) {
      console.error("Error uploading photo:", error);
      alert("An error occurred during the upload.");
    } finally {
      setIsCameraOpen(false);
    }
  }

  const helper = async () => {
    try {
      let res = await axios.post(
        `/api/v1/homework/preRead/update/${draftPreRead.id}`,
        createPreRead,
      );

      localStorage.setItem("buttons", "Draft");
      navigate("/PublishedHomeworkPreRead");
    } catch (error) {
      console.log(error);
    }
  };

  const isDisableButton =
    updatePreread.updateTittle === "" || updatePreread.description === "";

  const titleRejex = /^\s+/;
  const descriptionRejex = /^\s+/;

  const errors = {};
  if (updateTittle === (titleRejex.test(updateTittle) && updateTittle)) {
    errors.updateTittle = "Tittle can not start with a space";
  }
  if (description === (descriptionRejex.test(description) && description)) {
    errors.description = "Description can not start with a space";
  }

  const onChangeLinkValue = (value) => {
    setLinkValue(value);
  };

  const handleSaveLink = () => {
    if (attach.length >= 5) {
      toast.error("Maximum 5 attachments allowed");
      return;
    }

    if (linkValue.trim() === "" || !linkValue.startsWith("https://")) {
      toast.error("Please enter a valid link.");
      return;
    }

    setUpdatePreread((prev) => ({
      ...prev,
      attach: [...(prev.attach || []), linkValue],
    }));

    setLinkValue("");
    setShowLinkBox(false);
  };

  return draftPreRead ? (
    <>
      <div className="draft_preRead_all">
        <div className="d-flex align-items-center ">
          <Link to="/PublishedHomeworkPreRead">
            <img src="/images/Back Arrow.svg" alt="" />
          </Link>
          <Link to="/PublishedHomeworkPreRead " className="link">
            <span className="open_publish_path_pre">&nbsp; Draft /&nbsp;</span>
          </Link>
          <span className="open_publish_path1_pre"> {draftPreRead?.name}</span>
        </div>
        <div className="mt-3 ms-3 publishsub_heading_pre">
          {draftPreRead?.name}
        </div>
        <div class="Draft-text">
          <input
            type="text"
            value={updateTittle}
            maxLength={30}
            placeholder="Enter title"
            class="txt_draftName mt-3 form-control"
            id="txt-i-first"
            onChange={(e) => {
              setUpdatePreread({
                ...updatePreread,
                updateTittle: e.target.value,
              });
              setVisible(true);
            }}
          />
          {errors.updateTittle && (
            <span className="error">{errors.updateTittle}</span>
          )}
          <Form.Control
            as="textarea"
            maxLength={300}
            placeholder="Enter Description"
            value={description}
            rows={4}
            className="px-3 py-2 mt-4 txt_draftdesc"
            onChange={(e) => {
              setUpdatePreread({
                ...updatePreread,
                description: e.target.value,
              });
              setVisible(true);
            }}
          />
          {errors.description && (
            <span className="error">{errors.description}</span>
          )}
        </div>

        <Box
          sx={{
            mr: 3,
          }}
        >
          {/* Buttons Row */}
          <Stack
            direction="row"
            alignItems="center"
            spacing={3}
            flexWrap="wrap"
            sx={{ ml: 8, mt: 2 }}
          >
            {/* Add Link */}
            <Box
              onClick={() => !isProcessing && setShowLinkBox(!showLinkBox)}
              style={{
                opacity: isProcessing ? 0.5 : 1,
                pointerEvents: isProcessing ? "none" : "auto",
              }}
              className="cameraContainerActivity"
              sx={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Link size={20} />
              <Typography
                variant="body2"
                className="uploadHereText"
                sx={{ fontWeight: 500 }}
              >
                Add Link
              </Typography>
            </Box>

            {/* Upload Files */}
            <Box
              sx={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <input
                type="file"
                accept=".pdf,.jpg,.jpeg,.gif,.png,.mp3,.aac,.mp4,.mov,.wmv,.mpeg"
                id="attachFile"
                style={{ display: "none" }}
                disabled={isProcessing}
                onChange={(e) => {
                  handleFileChange(e);
                  e.target.value = null;
                }}
              />

              <label htmlFor="attachFile" style={{ cursor: "pointer" }}>
                <span className="cameraContainerAddAttachment d-flex align-items-center">
                  <img
                    src={assets.UploadIcon}
                    alt=""
                    style={{ width: "28px" }}
                  />
                  <Typography
                    variant="body2"
                    className="uploadHereText"
                    sx={{ ml: 1, fontWeight: 500 }}
                  >
                    Upload files
                  </Typography>
                </span>
              </label>

              {loader && <CircularProgress size={22} sx={{ ml: 1 }} />}
              {errorsize && (
                <Typography color="error">File must be under 10MB</Typography>
              )}
            </Box>

            {/* Camera Upload */}
            {!isCameraOpen ? (
              <Box
                onClick={() => !isProcessing && setIsCameraOpen(true)}
                style={{
                  opacity: isProcessing ? 0.5 : 1,
                  pointerEvents: isProcessing ? "none" : "auto",
                }}
                className="d-flex align-items-center gap-2 cameraContainerActivity"
                sx={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <img
                  src="/images/CameranewIcon.png"
                  alt=""
                  style={{ width: "33px" }}
                />
                <Typography
                  variant="body2"
                  className="uploadHereText"
                  sx={{ fontWeight: 500 }}
                >
                  Take Photo
                </Typography>
              </Box>
            ) : (
              <Box
                className="opened_camera"
                sx={{
                  mt: 2,
                  width: "100%",
                  position: "relative",
                  borderRadius: 2,
                  border: "1px solid #e0e0e0",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                  overflow: "hidden",
                  backgroundColor: "#fafafa",
                }}
              >
                {/* Close Icon */}
                <IconButton
                  onClick={() => setIsCameraOpen(false)}
                  size="small"
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    zIndex: 10,
                    backgroundColor: "rgba(255,255,255,0.8)",
                    "&:hover": { backgroundColor: "rgba(255,255,255,1)" },
                  }}
                >
                  <img
                    src={assets.closeIcon}
                    alt="close"
                    width={20}
                    height={20}
                  />
                </IconButton>

                {/* Camera Component */}
                <Box sx={{ position: "relative" }}>
                  <Camera
                    onTakePhoto={handleTakePhoto}
                    idealFacingMode="environment"
                    isImageMirror={false}
                    imageCompression={0.97}
                    isMaxResolution={true}
                    isSilentMode={false}
                    className="custom-camera"
                    // onCameraError={handleCameraError}
                  />
                </Box>

                {/* Camera Error Message */}
                {cameraError && (
                  <Box
                    sx={{
                      mt: 1.5,
                      mx: "auto",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "#ffebee",
                      border: "1px solid #f44336",
                      color: "#c62828",
                      borderRadius: 1,
                      px: 2,
                      py: 1,
                      width: "fit-content",
                      fontSize: "0.9rem",
                    }}
                  >
                    <ReportProblemRoundedIcon
                      sx={{ mr: 1, fontSize: "1.2rem", color: "#f44336" }}
                    />
                    {cameraError}
                  </Box>
                )}
              </Box>
            )}
          </Stack>

          {/* Attachments List */}
          <Box
            sx={{
              mt: 2,
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
              gap: 2,
              ml: 8,
            }}
          >
            {attach &&
              attach?.length !== 0 &&
              attach.map((attachment, index) => (
                <div style={{ margin: "10px" }}>
                  <PreDraftAttach
                    setAttach={setUpdatePreread}
                    updatePreread={updatePreread}
                    attachData={draftPreRead}
                    // newAttachment={newAttachment}
                    attach={attachment}
                  />
                </div>
              ))}
          </Box>
        </Box>
      </div>
      <div className="me-4 btn_draft_pre mt-2">
        <button
          className="btn px-3 m-1 py-2 pre_QDraft_button"
          onClick={() => {
            helper();
          }}
          disabled={isDisableButton}
        >
          Save as Draft
        </button>

        <button
          className="btn  m-1 py-2 prer_Qnext_button"
          onClick={(e) => setPublish(true)}
          disabled={isDisableButton}
        >
          Publish
        </button>
      </div>
      {publish && (
        <DraftPublishPreRead
          setPublish={setPublish}
          newPreRead={draftPreRead}
          updatePreread={updatePreread}
        />
      )}
      {showLinkBox && (
        <AddLinkPopup
          setShowLinkBox={setShowLinkBox}
          onChangeLinkValue={onChangeLinkValue}
          linkValue={linkValue}
          handleSaveLink={handleSaveLink}
        />
      )}
    </>
  ) : (
    <></>
  );
}
